import { useEffect, useState } from 'react'

import styles from './search-breadcrumbs.module.scss'
import { Breadcrumbs } from '@/components/styleguide/Breadcrumbs'
import { ROUTES } from '@/lib/routes'

export const SearchBreadcrumbs = ({ pageContent, isVans }) => {
  const [breadcrumbs, setBreadcrumbs] = useState([
    {
      icon: 'ChevronLeft',
      label: isVans ? 'Van leasing' : 'Car leasing',
      slug: isVans ? ROUTES.vanSearchPage.url : ROUTES.carSearchPage.url,
    },
  ])

  useEffect(() => {
    let crumbs = []

    if (!!pageContent && !!pageContent.breadcrumbLabel1) {
      crumbs.push({
        label: pageContent.breadcrumbLabel1,
        slug:
          !!pageContent.breadcrumbUrlKey1 && !!pageContent.breadcrumbLabel2
            ? `/${pageContent.breadcrumbUrlKey1}`
            : null,
      })

      if (pageContent.breadcrumbLabel2) {
        crumbs.push({
          label: pageContent.breadcrumbLabel2,
          slug: null,
        })
      }
    } else {
      crumbs.push({
        label: `${isVans ? 'Van ' : 'Car '}Search`,
        slug: null,
      })
    }

    setBreadcrumbs(crumbs)
  }, [pageContent, isVans])

  return (
    <Breadcrumbs
      hasPadding={false}
      className={styles.main}
      crumbs={breadcrumbs}
    />
  )
}
